
const T_SHIRT_SIZE_DEFAULT = 'Medium';
const T_SHIRT_SIZES = ['XSmall', 'Small', T_SHIRT_SIZE_DEFAULT, 'Large'];

const TRUST_AWARDS_DIRECTORY = 'awards';
const TRUST_CUSTOMERS_DIRECTORY = 'customers';

const TRUST_AWARDS = [

  {
    link: 'https://www.capterra.com/p/180545/Endtest/',
    name: 'Capterra',
    slug: `${TRUST_AWARDS_DIRECTORY}/capterra.png`,
    title: 'Capterra'
  },
  {
    link: 'https://www.g2.com/products/endtest/reviews',
    name: 'G2 Crowd',
    slug: `${TRUST_AWARDS_DIRECTORY}/g2crowd_badge.jpg`,
    title: 'G2 Crowd'
  },

  {
    link: 'https://www.howtoweb.co/startup-spotlight/',
    name: 'How To Web',
    slug: `${TRUST_AWARDS_DIRECTORY}/how-to-web.png`,
    title: 'How To Web'
  },
];


const TRUST_SECURITY = [
  {
    link: 'https://gdpr.eu/',
    name: 'GDPR',
    slug: `${TRUST_AWARDS_DIRECTORY}/gdpr1.png`,
    title: 'GDPR'
  },
  {
    link: 'https://www.iso.org/isoiec-27001-information-security.html',
    name: 'ISO',
    slug: `${TRUST_AWARDS_DIRECTORY}/iso2.png`,
    title: 'ISO 27001'
  },

  {
    link: 'https://www.hhs.gov/hipaa/index.html',
    name: 'HIPAA',
    slug: `${TRUST_AWARDS_DIRECTORY}/hipaa1.png`,
    title: 'HIPAA'
  },
];

const TRUST_CUSTOMERS = [
  {
    name: 'Red Bull',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/red_bull_logo.jpg`,
  },
  {
    name: 'Rakuten',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/rakuten_logo.jpg`,
  },
  {
    name: 'Intel',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/intel1.jpg`,
  },
  {
    name: 'Sodexo',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/sodexo.jpg`,
  },
  {
    name: 'HPE',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/hpe1.jpg`,
  },
  {
    name: 'Honeywell',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/honeywell1.jpg`,
  },

  {
    name: 'Vacasa',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/vacasa.jpg`,
  },
  {
    name: 'Lululemon',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/lululemon1.jpg`,
  },

  {
    name: 'Pepper',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/pepper.jpg`,
  },
  {
    name: 'AFL',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/afl_logo.jpg`,
  },
  {
    name: 'CafeX',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/cafex.jpg`,
  },
  {
    name: 'Michigan Lottery',
    slug: `${TRUST_CUSTOMERS_DIRECTORY}/michigan-lottery.jpg`,
  }


];

export { T_SHIRT_SIZE_DEFAULT, T_SHIRT_SIZES, TRUST_AWARDS, TRUST_CUSTOMERS, TRUST_SECURITY };
